/* eslint-disable vue/require-v-for-key */
<template>
  <!-- 质检任务 -->
  <div class="max_box">
    <!-- top -->
    <div class="top_box"><span class="top_span">质检任务</span></div>
    <!-- query -->
    <span style="margin-top: 15px;">
      <el-input size="small" placeholder="请输入任务名称" v-model="pageBuild.taskName" class="input-with-select"
                style="width:320px;">
        <el-button @click="search" size="small" slot="append" icon="el-icon-search"></el-button>
      </el-input>
     </span>
    <span style="margin-top: 15px;margin-left:15px;">
       <el-button style="width:140px;" @click="openDialog()" icon="el-icon-plus" size="small"
                  type="success">新增质检任务</el-button>
     </span>
    <!-- table -->
    <el-table stripe class="table_box_el_table" :data="tableData" v-loading="load_table" @filter-change="filterChange">
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"></el-table-column>
      <el-table-column label="任务名称" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span class="table_span">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="质检范围"
        align="center"
        width="420px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span v-if="scope.row.showRangValue" class="table_span">{{ scope.row.showRangValue }}</span>
          <span v-if="!scope.row.showRangValue" class="table_span">--</span>
        </template>
      </el-table-column>
      <el-table-column label="执行方案" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
                    <span v-for="plan in qcPlanList" :key="plan.id">
                      <div v-if="plan.id == scope.row.planId">{{ plan.name }}</div>
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="执行频率" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span v-show="scope.row.runRate.includes('d')" class="table_span">每日一次 </span>
          <span v-show="scope.row.runRate.includes('w')"
                class="table_span">每周 {{ scope.row.runRate.substr(scope.row.runRate.lastIndexOf(":") + 1, scope.row.runRate.length) }} 一次</span>
          <span v-show="scope.row.runRate.includes('m')"
                class="table_span">每月 {{ scope.row.runRate.substr(scope.row.runRate.lastIndexOf(":") + 1, scope.row.runRate.length) }} 号一次</span>
          <span v-show="scope.row.runRate.includes('o')" class="table_span">单次 </span>
        </template>
      </el-table-column>
      <el-table-column width="120px" label="执行时间" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span class="table_span">{{ scope.row.runTime }}</span>
        </template>
      </el-table-column>
<!--      <el-table-column-->
<!--        label="分配小组"-->
<!--        align="center"-->
<!--        :show-overflow-tooltip="true">-->
<!--        <template slot-scope="scope" :show-overflow-tooltip="true">-->
<!--          <span class="table_span">{{ scope.row.skillGroupId }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column label="任务描述" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          <el-popover-->
<!--            placement="top"-->
<!--            width="200"-->
<!--            trigger="hover"-->
<!--            :disabled="scope.row.describ.length<=6"-->
<!--            :content="scope.row.describ">-->
<!--            <span slot="reference" v-if="scope.row.describ"-->
<!--                  class="table_span">{{ scope.row.describ.length > 6 ? scope.row.describ.substr(0, 5) + '...' : scope.row.describ }}</span>-->
<!--            <span slot="reference" v-if="!scope.row.describ" class="table_span">&#45;&#45;</span>-->
<!--          </el-popover>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column
        label="状态"
        align="center"
        :show-overflow-tooltip="true"
        :filters="[{ text: '启用', value: 1 }, { text: '禁用', value: 0 }]"
        :filter-multiple="false"
        :column-key="'status'">
        <template slot-scope="scope">
          <el-switch @change="updatedStatus(scope.row.id,scope.row.status)" v-model="scope.row.status" :active-value="1"
                     :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="130">
        <template slot-scope="scope">
          <div class="table_button_box">
            <el-tooltip class="item" effect="dark" content="编辑" placement="top">
              <el-button icon="el-icon-edit"
                         class="table_button" circle size="mini" @click="openDialog(scope.row.id)" type="primary">
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top">
              <el-button @click="remove(scope.row.id)"
                         :icon="remove_id==scope.row.id?'el-icon-loading':'el-icon-delete'"
                         class="table_button" circle size="mini" type="danger">
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="测试" placement="top">
              <el-button @click="testTask(scope.row.id)"
                         :icon="'el-icon-s-promotion'"
                         class="table_button" circle size="mini" type="danger">
              </el-button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- page -->
    <Page v-bind:init_item="pageBuild" @currentPage="currentPage"/>
    <!-- drawer -->
    <el-drawer
      :title="drawerTitle"
      :wrapperClosable="wrapperClosable"
      style="font-size:18px;"
      :before-close="cancelForm"
      :visible.sync="dialog"
      custom-class="demo-drawer"
      size="50%;">
      <div class="demo-drawer__content" style="margin-left:10px;margin-bottom:20px;">
        <!-- form -->
        <el-form :model="formData" :rules="rules" ref="ruleForm">
          <el-form-item label="任务名称" :label-width="formLabelWidth" prop="name">
            <el-input class="drawer_input" v-model="formData.name" autocomplete="off" placeholder="请输入任务名称"></el-input>
          </el-form-item>
          <el-form-item label="任务描述" :label-width="formLabelWidth">
            <el-input
              class="drawer_input"
              type="textarea"
              placeholder="请输入内容"
              v-model="formData.describ"
              rows="4"
              maxlength="200"
              show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item label="质检范围" :label-width="formLabelWidth">
            <!--质检范围 弹出层 popover -->
            <el-popover
              placement="bottom-start"
              trigger="manual"
              v-model="visible">
              <el-button type="info" plain style="width:232px;" slot="reference" @click="visible = true;showRang()"
                         size="small" round>筛选器 <i class="el-icon-sort"></i></el-button>
              <div style="width:650px;">
                <el-row v-for="obj in qcTaskRangList" :key="obj.key" style="margin-top:15px;">
                  <el-col :span="7">
                    <div class="grid-content bg-purple">
                      <el-select v-model="obj.rangType" size="small" @change="changRangType(obj)">
                        <el-option
                          v-for="item in QcOptions1"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </el-col>
                  <el-col :span="5">
                    <div class="grid-content bg-purple">
                      <el-select :disabled="obj.flagDisabled" v-model="obj.match" size="small">
                        <el-option
                          v-for="item in QcOptions2"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </el-col>
                  <el-col :span="7">
                    <div class="grid-content bg-purple">
                      <el-input v-model="obj.rangValue" style="width: 180px" size="small" v-if="obj.rangType === 1"
                                autocomplete="off"></el-input>
                      <el-date-picker
                        v-else
                        style="width: 180px"
                        v-model="obj.rangValue"
                        type="datetime"
                        size="small"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                      </el-date-picker>
                    </div>
                  </el-col>
                  <el-col :span="3">
                    <div class="grid-content bg-purple">
                      <el-button v-if="obj.isRelation" size="small" @click="changRelation(obj.key,obj.relationOther)"
                                 style="width:65px;">{{ obj.relationOther }}
                      </el-button>
                    </div>
                  </el-col>
                  <el-col :span="2">
                    <div class="grid-content bg-purple">
                      <el-button v-if="obj.status==1" circle icon="el-icon-plus" type="primary" size="mini"
                                 @click="addQcRangRow"></el-button>
                      <el-button v-if="obj.status==0" circle icon="el-icon-delete" type="danger" size="mini"
                                 @click="removeQcRangRow(obj.key)"></el-button>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div style="text-align:left;margin-top:20px;">
                坐席组
                <el-select filterable v-model="rangSkillGroupId">
                  <el-option
                    v-for="item in disGroupOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div style="text-align:center;margin-top:30px;">
                <el-button size="mini" @click="visible = false"> 取消</el-button>
                <el-button type="primary" size="mini" @click="saveRang()"> 确定</el-button>
              </div>
            </el-popover>
          </el-form-item>
          <el-form-item label="执行频率" :label-width="formLabelWidth">
            <el-select @change="changeRunRate" v-model="runRate">
              <el-option
                v-for="item in runRateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!--执行时间 start  -->
          <el-form-item v-if="runRate.includes('d')" label="执行时间" :label-width="formLabelWidth" prop="runTime">
            每日
            <el-time-picker
              :clearable="clearable"
              style="width:204px;"
              v-model="formData.runTime"
              format="HH:mm"
              value-format="HH:mm">
            </el-time-picker>
          </el-form-item>
          <el-form-item v-if="runRate.includes('w')" label="执行时间" :label-width="formLabelWidth" prop="runTime">
            每周
            <el-select v-model="formData.week" style="width:75px;">
              <el-option
                v-for="item in runTimeOptions1"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-time-picker
              :clearable="clearable"
              style="width:114px;margin-left:15px;"
              v-model="formData.runTime"
              format="HH:mm"
              value-format="HH:mm">
            </el-time-picker>
          </el-form-item>
          <el-form-item v-if="runRate.includes('m')" label="执行时间" :label-width="formLabelWidth" prop="runTime">
            每月
            <el-select v-model="formData.number" style="width:76px;">
              <el-option
                v-for="item in runTimeOptions2"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            号
            <el-time-picker
              :clearable="clearable"
              style="width:111px;"
              v-model="formData.runTime"
              format="HH:mm"
              value-format="HH:mm">
            </el-time-picker>
          </el-form-item>
          <el-form-item v-if="runRate.includes('o')" label="执行时间" :label-width="formLabelWidth" prop="runTime">
            单次
            <el-time-picker
              :clearable="clearable"
              style="width:204px;"
              v-model="formData.runTime"
              format="HH:mm"
              value-format="HH:mm">
            </el-time-picker>
          </el-form-item>
          <!--执行时间 end  -->
          <el-form-item label="分配小组" :label-width="formLabelWidth" prop="skillGroupId">
            <el-select filterable v-model="formData.skillGroupId">
              <el-option
                v-for="item in disGroupOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 抽检策略 start -->
          <el-form-item label="抽检策略" :label-width="formLabelWidth">
            <el-row v-for="obj in formData.qcTaskCheckList" :key="obj.key" :style="obj.key>1?'margin-top:10px;':''">
              <el-col :span="6">
                <el-select v-model="obj.checkType">
                  <el-option
                    v-for="item in sportCheckOptions1"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="3">
                <el-select v-model="obj.match">
                  <el-option
                    v-for="item in sportCheckOptions2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-input v-model="obj.checkValue" autocomplete="off"></el-input>
              </el-col>
              <el-col :span="2" style="margin-left:10px;min-width:70px;">抽检比例</el-col>
              <el-col :span="4">
                <el-input v-model="obj.scale" autocomplete="off"></el-input>
              </el-col>
              <el-col :span="2" style="margin-left:10px;">
                <el-button circle icon="el-icon-plus" type="primary" style="padding-left:7px;padding-right:7px;"
                           v-if="obj.status==1" size="mini" @click="addSportCheckRow"></el-button>
                <el-button circle icon="el-icon-delete" type="danger" style="padding-left:7px;padding-right:7px;"
                           v-if="obj.status==0" size="mini" @click="removeSportCheckRow(obj.key)"></el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <!-- 抽检策略 end -->
          <el-form-item label="执行方案" :label-width="formLabelWidth" prop="planId">
            <el-select v-model="formData.planId" filterable placeholder="请选择" @change="changePlan">
              <el-option
                v-for="item in qcPlanList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-row>
            <el-col :span="5">
              <el-form-item label="扣分上限" :label-width="formLabelWidth" style="color:green;">
                {{ plan.deductLimit }} <i v-if="Math.abs(plan.deductLimit)>=0" class="el-icon-sort-down"></i>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="加分上限" :label-width="formLabelWidth" style="color:red;">
                {{ plan.bonusLimit }} <i v-if="Math.abs(plan.bonusLimit)>=0" class="el-icon-sort-up"></i>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 质检项 table-->
        <el-tabs v-model="classify" type="card" @tab-click="changeClassify">
          <el-tab-pane label="扣分项" name="1">
            <el-table stripe :data="filterQcItems" class="dialog_table" max-height="360">
              <el-table-column align="center" label="序号" type="index" width="50"></el-table-column>
              <el-table-column align="center" property="name" label="质检名称"
                               :show-overflow-tooltip="true"></el-table-column>
              <el-table-column align="center" property="remark" label="说明"
                               :show-overflow-tooltip="true"></el-table-column>
              <el-table-column align="center" property="modelId" label="质检模型"
                               :show-overflow-tooltip="true"></el-table-column>
              <el-table-column align="center" property="score" label="分值"></el-table-column>
              <el-table-column align="center" label="类型">
                <template slot-scope="scope">
                  <span class="table_span">{{ scope.row.type == 1 ? '正向' : '负向' }}<i v-if="scope.row.type==1"
                                                                                     class="el-icon-sort-up"></i><i
                    v-if="scope.row.type==2" class="el-icon-sort-down"></i></span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="加分项" name='2'>
            <el-table stripe :data="filterQcItems" class="dialog_table" max-height="360">
              <el-table-column align="center" label="序号" type="index" width="50"></el-table-column>
              <el-table-column align="center" property="name" label="质检名称"
                               :show-overflow-tooltip="true"></el-table-column>
              <el-table-column align="center" property="remark" label="说明"
                               :show-overflow-tooltip="true"></el-table-column>
              <el-table-column align="center" property="modelId" label="质检模型"
                               :show-overflow-tooltip="true"></el-table-column>
              <el-table-column align="center" property="score" label="分值"></el-table-column>
              <el-table-column align="center" label="类型">
                <template slot-scope="scope">
                  <span class="table_span">{{ scope.row.type == 1 ? '正向' : '负向' }}<i v-if="scope.row.type==1"
                                                                                     class="el-icon-sort-up"></i><i
                    v-if="scope.row.type==2" class="el-icon-sort-down"></i></span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="致命项" name='3'>
            <el-table stripe :data="filterQcItems" class="dialog_table" max-height="360">
              <el-table-column align="center" label="序号" type="index" width="50"></el-table-column>
              <el-table-column align="center" property="name" label="质检名称"
                               :show-overflow-tooltip="true"></el-table-column>
              <el-table-column align="center" property="remark" label="说明"
                               :show-overflow-tooltip="true"></el-table-column>
              <el-table-column align="center" property="modelId" label="质检模型"
                               :show-overflow-tooltip="true"></el-table-column>
              <el-table-column align="center" label="类型">
                <template slot-scope="scope">
                  <span class="table_span">{{ scope.row.type == 1 ? '正向' : '负向' }}<i v-if="scope.row.type==1"
                                                                                     class="el-icon-sort-up"></i><i
                    v-if="scope.row.type==2" class="el-icon-sort-down"></i></span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <div class="demo-drawer__footer">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="submitForm" :loading="loading">{{ loading ? '提交中 ...' : '保 存' }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { taskList, saveTask, deleteTask, getTaskById, updateTask, allQcPlan, getQcItemsByPlanId, updateTaskStatus, testTaskById } from '@/api/qc/qcTask.js'
import { getCustomerGroup } from '@/api/qc/model.js'
import Page from '@/views/qc/public/PageComponent'
export default {
  name: 'modelManagement',
  components: {
    Page
  },
  data: function () {
    return {
      qcTaskRangList: [],
      rangSkillGroupId: '',
      wrapperClosable: false,
      drawerTitle: '新增质检任务',
      clearable: false,
      runRate: '1d:1',
      visible: false,
      popoverWidth: '80%',
      table: false,
      dialog: false,
      loading: false,
      sportCheckOptions1: [{
        value: 1,
        label: '通话时长'
      }, {
        value: 2,
        label: '得分'
      }, {
        value: 3,
        label: '客服工号'
      }],
      disGroupOptions: [],
      sportCheckOptions2: [{
        value: '>=',
        label: '>='
      }, {
        value: '>',
        label: '>'
      }, {
        value: '=',
        label: '='
      }, {
        value: '<=',
        label: '<='
      }, {
        value: '<',
        label: '<'
      }],
      runTimeOptions2: [{
        value: 1,
        label: '1'
      }, {
        value: 2,
        label: '2'
      }, {
        value: 3,
        label: '3'
      }, {
        value: 4,
        label: '4'
      }, {
        value: 5,
        label: '5'
      }, {
        value: 6,
        label: '6'
      }, {
        value: 7,
        label: '7'
      }, {
        value: 8,
        label: '8'
      }, {
        value: 9,
        label: '9'
      }, {
        value: 10,
        label: '10'
      }, {
        value: 11,
        label: '11'
      }, {
        value: 12,
        label: '12'
      }, {
        value: 13,
        label: '13'
      }, {
        value: 14,
        label: '14'
      }, {
        value: 15,
        label: '15'
      }, {
        value: 16,
        label: '16'
      }, {
        value: 17,
        label: '17'
      }, {
        value: 18,
        label: '18'
      }, {
        value: 19,
        label: '19'
      }, {
        value: 20,
        label: '20'
      }, {
        value: 21,
        label: '21'
      }, {
        value: 22,
        label: '22'
      }, {
        value: 23,
        label: '23'
      }, {
        value: 24,
        label: '24'
      }, {
        value: 25,
        label: '25'
      }, {
        value: 26,
        label: '26'
      }, {
        value: 27,
        label: '27'
      }, {
        value: 28,
        label: '28'
      }, {
        value: 29,
        label: '29'
      }, {
        value: 30,
        label: '30'
      }, {
        value: 31,
        label: '31'
      }],
      runTimeOptions1: [{
        value: 1,
        label: '1'
      }, {
        value: 2,
        label: '2'
      }, {
        value: 3,
        label: '3'
      }, {
        value: 4,
        label: '4'
      }, {
        value: 5,
        label: '5'
      }, {
        value: 6,
        label: '6'
      }, {
        value: 7,
        label: '7'
      }],
      runRateOptions: [{
        value: '1d:1',
        label: '每日一次'
      }, {
        value: '1w:1',
        label: '每周一次'
      }, {
        value: '1m:1',
        label: '每月一次'
      }, {
        value: '1o:1',
        label: '单次'
      }],
      QcOptions1: [{
        value: 1,
        label: '会话时长'
      }, {
        value: 2,
        label: '会话开始日期'
      }, {
        value: 3,
        label: '会话结束日期'
      }],
      QcOptions2: [{
        value: '>=',
        label: '>='
      }, {
        value: '=',
        label: '='
      }, {
        value: '<=',
        label: '<='
      }],
      qcPlanList: [],
      formData: {
        id: '',
        name: '',
        describ: '',
        runRate: '',
        runTime: '06:00',
        week: 1,
        number: 1,
        planId: '',
        status: 0,
        skillGroupId: '',
        rangSkillGroupId: '',
        qcTaskRangList: [], // 筛选器
        qcTaskCheckList: [] // 抽检策略多行参数
      },
      rules: {
        name: [
          { required: true, message: '请输入任务名称', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        runTime: [
          { required: true, message: '请输入执行时间', trigger: 'blur' }
        ],
        planId: [
          { required: true, message: '请选择执行方案', trigger: 'blur' }
        ],
        skillGroupId: [
          { required: true, message: '请选择分配小组', trigger: 'blur' }
        ]
      },
      formLabelWidth: '80px',
      timer: null,
      tableData: [],
      remove_id: '',
      load_table: false,
      pageBuild: { // 分页与查询参数
        page_size: 10,
        total: 0,
        currentPage: 1,
        taskName: '',
        status: ''
      },
      plan: {},
      qcItems: [],
      filterQcItems: [],
      classify: '1',
      rowNumber: 5
    }
  },
  methods: {
    changePlan() { // 修改执行方案
      const that = this
      that.qcPlanList.forEach(
        function(plan, index, arr) {
          that.classify = '1'
          // eslint-disable-next-line eqeqeq
          if (plan.id == that.formData.planId) {
            that.plan = plan
            that.getQcItems(plan.id)
          }
        }
      )
    },
    formDataInit() { // 初始化表单参数
      // const now = new Date()
      this.formData = {
        id: '',
        name: '',
        describ: '',
        runRate: '',
        // runTime: now.getHours + ':' + now.getMinutes,
        runTime: '06:00',
        week: 1,
        number: 1,
        planId: '',
        deductLimit: 0,
        bonusLimit: 0,
        status: 0,
        skillGroupId: '',
        rangSkillGroupId: '',
        qcTaskCheckList: [],
        qcTaskRangList: []
      }
      this.plan = {}
      this.runRate = '1d:1'
      this.qcItems = []
      this.filterQcItems = []
      this.classify = '1'
      this.qcTaskRangList = []
      this.rangSkillGroupId = ''
    },
    getQcPlanList() { // 获取质检方案列表
      allQcPlan().then(res => {
        this.qcPlanList = res.data.data
      })
    },
    updatedStatus(id, status) { // 修改任务状态
      const that = this
      // eslint-disable-next-line no-unused-vars
      // eslint-disable-next-line eqeqeq
      window.qcMessageBox({
        title: '',
        text: '确定修改状态吗？',
        f: function() {
          // eslint-disable-next-line eqeqeq
          updateTaskStatus({ id: id, status: status }).then(res => {
            window.qcMessage({ type: 'success', text: '修改成功' })
            that.search()
          }).catch(res => {
            window.qcMessage({ type: 'error', text: '系统异常' })
          })
        },
        c: function() { that.search() }
      })
    },
    changeRunRate() { // 格式化所选频率为可以提交的value
      this.formData.runRate = this.runRate + ':' + this.formData.week + this.formData.number
    },
    changRelation(index, relation) { // 质检范围关系修改
      // eslint-disable-next-line eqeqeq
      const that = this
      relation = relation === 'AND' ? 'OR' : 'AND'
      this.qcTaskRangList.forEach(function(item, idx, arr) {
        // eslint-disable-next-line eqeqeq
        if (index == item.key) { // 按照索引删除行
          that.qcTaskRangList[idx].relationOther = relation
        }
      })
    },
    resetForm() { // 还原form表单验证
      this.$refs.ruleForm.resetFields()
    },
    submitForm() { // 提交form表单
      const that = this
      if (that.loading) {
        return
      }
      if (that.formData.qcTaskCheckList && that.formData.qcTaskCheckList.length > 0) {
        let flag = true
        that.formData.qcTaskCheckList.forEach(function (item, index, array) {
          if (!item.checkValue || item.checkValue === '') {
            window.qcMessage({ type: 'error', text: '抽检策略值不能为空' })
            flag = false
            return false
          }

          if (!item.scale || item.scale === '') {
            window.qcMessage({ type: 'error', text: '抽检比例值不能为空' })
            flag = false
            return false
          }
        })
        if (!flag) {
          return false
        }
      }
      that.$refs.ruleForm.validate((valid) => {
        if (valid) {
          window.qcMessageBox({
            title: '',
            text: '确认要提交表单吗？',
            f: function() { // 确认提交form表单操作
              that.loading = true
              // eslint-disable-next-line eqeqeq
              if (that.runRate.includes('w')) {
                that.formData.runRate = that.runRate + ':' + that.formData.week
              } else if (that.runRate.includes('m')) {
                that.formData.runRate = that.runRate + ':' + that.formData.number
              } else {
                that.formData.runRate = that.runRate
              }

              // eslint-disable-next-line eqeqeq
              if (that.formData.id == '' || that.formData.id == null) { // 新增任务逻辑
                saveTask(that.formData).then(res => {
                  that.timer = setTimeout(() => {
                    // 动画关闭需要一定的时间
                    setTimeout(() => {
                      // eslint-disable-next-line eqeqeq
                      if (res.data.code == 2000) {
                        window.qcMessage({ type: 'success', text: '提交成功' })
                        that.search()
                        that.cancelForm()
                      } else {
                        window.qcMessage({ type: 'error', text: res.data.msg })
                        that.loading = false
                      }
                    }, 400)
                  }, 500)
                }).catch(res => {
                  window.qcMessage({ type: 'error', text: '系统异常' })
                })
              } else {
                updateTask(that.formData).then(res => { // 修改任务逻辑
                  that.timer = setTimeout(() => {
                    // 动画关闭需要一定的时间
                    setTimeout(() => {
                      // eslint-disable-next-line eqeqeq
                      if (res.data.code == 2000) {
                        window.qcMessage({ type: 'success', text: '提交成功' })
                        that.search()
                        that.cancelForm()
                      } else {
                        window.qcMessage({ type: 'error', text: res.data.msg })
                        that.loading = false
                      }
                    }, 400)
                  }, 500)
                }).catch(res => {
                  window.qcMessage({ type: 'error', text: '系统异常' })
                })
              }
            },
            c: function() { } // 取消form表单提交操作
          })
        } else {
          return false
        }
      })
    },
    cancelForm() { // 关闭弹出层
      this.loading = false
      this.dialog = false
      clearTimeout(this.timer)
      this.resetForm()
      this.visible = false
    },
    openDialog(id) { // 打开弹出层
      const that = this
      that.formDataInit()
      that.dialog = true
      if (id) { // 修改任务逻辑
        that.drawerTitle = '修改质检任务'
        getTaskById(id).then(res => {
          const d = res.data.data
          that.formData.id = d.id
          that.formData.describ = d.describ
          that.formData.name = d.name
          that.formData.planId = d.planId
          that.formData.runRate = d.runRate
          that.formData.runTime = d.runTime
          that.formData.status = d.status
          that.formData.skillGroupId = d.skillGroupId
          that.formData.rangSkillGroupId = d.rangSkillGroupId
          if (d.qcTaskCheckList && d.qcTaskCheckList.length > 0) {
            that.formData.qcTaskCheckList = d.qcTaskCheckList
            that.formData.qcTaskCheckList.forEach(function (item, index, array) {
              item.key = index + 1
              if (index === 0) {
                item.status = 1
              } else {
                item.status = 0
              }
            })
          } else {
            that.formData.qcTaskCheckList = [{ key: 1, status: 1, checkType: 1, match: '>=', checkValue: '', scale: '' }]
          }
          if (d.qcTaskRangList && d.qcTaskRangList.length > 0) {
            that.formData.qcTaskRangList = d.qcTaskRangList
          }
          that.changePlan()
          if (that.formData.runRate.includes('d') || that.formData.runRate.includes('o')) {
            that.runRate = that.formData.runRate
          } else {
            that.runRate = that.formData.runRate.substr(0, that.formData.runRate.lastIndexOf(':'))
          }
          if (that.formData.runRate.includes('w')) {
            that.formData.week = Number(that.formData.runRate.substr(that.formData.runRate.lastIndexOf(':') + 1, that.formData.runRate.length))
          }
          if (that.formData.runRate.includes('m')) {
            that.formData.number = Number(that.formData.runRate.substr(that.formData.runRate.lastIndexOf(':') + 1, that.formData.runRate.length))
          }
          // that.getQcItems(d.planId)
        }).catch(res => {
          window.qcMessage({ type: 'error', text: '系统异常' })
        })
      } else { // 新增任务逻辑
        that.drawerTitle = '新增质检任务'
        that.formData.qcTaskCheckList = [{ key: 1, status: 1, checkType: 1, match: '>=', checkValue: '', scale: '' }]
        that.dialog = true
      }
    },
    remove(id) { // 删除任务
      // eslint-disable-next-line eqeqeq
      if (id == this.remove_id) return
      const that = this
      that.remove_id = id
      // eslint-disable-next-line no-undef
      window.qcMessageBox({
        title: '',
        text: '确定要删除吗？',
        f: function() {
          deleteTask(that.remove_id).then(res => {
            // eslint-disable-next-line eqeqeq
            if (res.data.code == 2000) {
              window.qcMessage({ type: 'success', text: '删除成功' })
              that.search()
              that.remove_id = ''
            }
          }).catch(res => {
            window.qcMessage({ type: 'error', text: '系统异常' })
          })
        },
        c: function() { that.remove_id = '' }
      })
    },
    indexMethod(index) { // 任务table序号生成
      return index + 1 + this.pageBuild.page_size * (this.pageBuild.currentPage - 1)
    },
    currentPage(currentPage) { // 分页跳转
      // this.pageBuild.currentPage = currentPage
      this.search(currentPage)
    },
    search(currentPage) { // 搜索任务
      const that = this
      that.load_table = true
      // console.log(typeof currentPage)
      // eslint-disable-next-line no-unneeded-ternary
      // eslint-disable-next-line eqeqeq
      that.pageBuild.currentPage = typeof currentPage == 'number' ? currentPage : 1
      taskList(that.pageBuild).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.data.code == 2000) {
          that.tableData = res.data.data.root
          that.tableData.forEach(function(item, index, arr) {
            item.showRangValue = ''
            if (item.qcTaskRangList && item.qcTaskRangList.length > 0) {
              for (let i = 0; i < item.qcTaskRangList.length; i++) {
                if (item.qcTaskRangList[i].rangType === 1) {
                  item.showRangValue = item.showRangValue + ' 会话时长'
                } else if (item.qcTaskRangList[i].rangType === 2) {
                  item.showRangValue = item.showRangValue + ' 会话开始时间'
                } else {
                  item.showRangValue = item.showRangValue + ' 会话结束时间'
                }
                item.showRangValue = item.showRangValue + item.match + item.qcTaskRangList[i].rangValue
                if (i !== item.qcTaskRangList.length - 1) {
                  if (item.qcTaskRangList[i].match === 'AND') {
                    item.showRangValue = item.showRangValue + ' 并且'
                  } else {
                    item.showRangValue = item.showRangValue + ' 或者'
                  }
                }
              }
            }
            that.disGroupOptions.forEach(function(obj, idx, array) {
              // eslint-disable-next-line eqeqeq
              if (item.skillGroupId == obj.id) {
                item.skillGroupId = obj.name
              }
              if (item.rangSkillGroupId && item.rangSkillGroupId !== '' && item.rangSkillGroupId === obj.id) {
                if (item.showRangValue && item.showRangValue !== '') {
                  item.showRangValue = item.showRangValue + ' 并且 '
                }
                item.showRangValue = item.showRangValue + '坐席组=' + obj.name
              }
            })
          })
          that.pageBuild.total = res.data.data.totalProperty
          that.load_table = false
        }
      }).catch(res => {
        window.qcMessage({ type: 'error', text: '系统异常' })
        that.load_table = false
      })
    },
    filterChange: function (value) { // 过滤任务状态
      if (value.status && value.status.length > 0) {
        this.pageBuild.status = value.status[0]
        this.search()
      } else {
        this.pageBuild.status = ''
        this.search()
      }
    },
    getQcItems(planId) { // 获取质检项列表
      const that = this
      that.filterQcItems = []
      getQcItemsByPlanId(planId).then(res => {
        that.qcItems = res.data.data
        that.qcItems.forEach(function(item, index, arr) {
          // eslint-disable-next-line eqeqeq
          if (that.classify == item.classify) {
            that.filterQcItems.push(item)
          }
        })
      }).catch(res => {
        that.qcItems = []
        that.filterQcItems = []
      })
    },
    changeClassify() { // 筛选质检项列表
      const that = this
      that.filterQcItems = []
      that.qcItems.forEach(function(item, idx, arr) {
        // eslint-disable-next-line eqeqeq
        if (that.classify == item.classify) {
          that.filterQcItems.push(item)
        }
      })
    },
    addQcRangRow() { // 质检范围添加行逻辑
      const that = this
      if (that.qcTaskRangList.length === that.rowNumber) return // 添加行数限制
      that.qcTaskRangList[that.qcTaskRangList.length - 1].isRelation = 1 // 是否展示and或or关系按钮
      const item = { key: that.qcTaskRangList[that.qcTaskRangList.length - 1].key + 1, status: 0, rangType: 1, match: '>=', rangValue: '', relationOther: 'AND', isRelation: 0 }
      that.qcTaskRangList.push(item)
    },
    removeQcRangRow(index) { // 质检范围删除行逻辑
      const that = this
      that.qcTaskRangList.forEach(function(item, idx, arr) {
        // eslint-disable-next-line eqeqeq
        if (index == item.key) {
          // eslint-disable-next-line eqeqeq
          if (!(that.qcTaskRangList.length > 2 && idx < that.qcTaskRangList.length - 1)) { // 当前行数大于2，并且点击了删除第2行，则不能去掉前一行的（and或or）关系，反之则可以去掉
            that.qcTaskRangList[idx - 1].isRelation = 0
          }
          that.qcTaskRangList.splice(idx, 1) // 按照索引删除行
        }
      })
    },
    addSportCheckRow() { // 抽检策略添加行逻辑
      const that = this
      // eslint-disable-next-line eqeqeq
      if (that.formData.qcTaskCheckList.length == that.rowNumber) return // 添加行数限制
      const item = { key: that.formData.qcTaskCheckList[that.formData.qcTaskCheckList.length - 1].key + 1, status: 0, checkType: 1, match: '>=', checkValue: '', scale: '' }
      that.formData.qcTaskCheckList.push(item)
    },
    removeSportCheckRow(index) { // 抽检策略删除行逻辑
      const that = this
      that.formData.qcTaskCheckList.forEach(function(item, idx, arr) {
        // eslint-disable-next-line eqeqeq
        if (index == item.key) { // 按照索引删除行
          that.formData.qcTaskCheckList.splice(idx, 1)
        }
      })
    },
    getCustomerGroupInfo() {
      const that = this
      that.disGroupOptions = []
      getCustomerGroup().then(res => {
        const data = res.data.data
        that.disGroupOptions = data
      }).catch(res => {

      })
    },
    saveRang() {
      let flag = true
      const that = this
      if (this.qcTaskRangList && this.qcTaskRangList.length > 0) {
        this.qcTaskRangList.forEach(function(item, idx, arr) {
          if (!item.rangValue || item.rangValue === '') {
            window.qcMessage({ type: 'error', text: '会话时长不能为空' })
            flag = false
            return false
          }
        })
      }
      if (!flag) {
        return false
      }
      that.formData.qcTaskRangList = []
      this.qcTaskRangList.forEach(function(item, idx, arr) {
        const obj = JSON.parse(JSON.stringify(item))
        obj.seq = obj.key
        that.formData.qcTaskRangList.push(obj)
      })
      this.formData.rangSkillGroupId = this.rangSkillGroupId + ''
      this.visible = false
    },
    showRang() {
      const that = this
      this.rangSkillGroupId = this.formData.rangSkillGroupId + ''
      if (this.formData.qcTaskRangList && this.formData.qcTaskRangList.length > 0) {
        this.qcTaskRangList = []
        this.formData.qcTaskRangList.forEach(function(item, idx, arr) {
          const newItem = JSON.parse(JSON.stringify(item))
          newItem.key = item.seq
          if (idx === 0) {
            newItem.status = 1
          } else {
            newItem.status = 0
          }
          if (idx === that.formData.qcTaskRangList.length - 1) {
            newItem.isRelation = 0
          } else {
            newItem.isRelation = 1
          }
          if (newItem.rangType === 2 || newItem.rangType === 3) {
            newItem.flagDisabled = true
          } else {
            newItem.flagDisabled = false
          }
          that.qcTaskRangList.push(newItem)
        })
      } else {
        that.qcTaskRangList = [{ key: 1, status: 1, rangType: 1, match: '>=', rangValue: '', relationOther: 'AND', isRelation: 0 }]
      }
    },
    testTask(id) { // 删除任务
      testTaskById(id).then(res => {
      }).catch(res => {
        window.qcMessage({ type: 'error', text: '系统异常' })
      })
    },
    changRangType(obj) {
      if (obj.rangType === 2) {
        obj.match = '>='
        obj.flagDisabled = true
      } else if (obj.rangType === 3) {
        obj.match = '<='
        obj.flagDisabled = true
      } else {
        obj.match = '>='
        obj.flagDisabled = false
      }
      obj.rangValue = ''
    }

  },
  mounted() {
    this.getQcPlanList()
    this.getCustomerGroupInfo()
    this.search()
  }
}
</script>

<style  scoped>
    .drawer_input{
        width: 80%;
    }
    .max_box{
        width: 100%;
    }
    .top_box{
        width: 100%;
        border-bottom: #e1e3e6 solid 1px;
        padding-top: 12px;
        padding-bottom: 9px;
        margin-bottom: 20px;
    }
    .top_span{
        color: #222;
        font-size: 20px;
        padding-bottom: 10px;
        border-bottom: #0080fe solid 1px;
        padding-right: 5px;
    }
    .form_box{
        width: 100%;
        margin-bottom: 10px;
    }
    .form_label{
        font-size: 14px;
    }
    .form_input{
        width: 200px;
        margin-right: 20px;
    }
    .table_span{
        margin-left: 5px;
    }
    .table_box_el_table >>> .el-table__body-wrapper >.el-table__body tbody tr .el-table_1_column_1 .cell div{
        width: 22px !important;
        border-radius: 15px;
        background: #eee;
        margin-left: 2px;
    }
    /deep/.el-drawer{
        overflow: auto;
    }
    /deep/.dialog_table{
      overflow: auto;
      /* max-height: 360px; */
    }
  .el-drawer__wrapper >>> .el-drawer__header > span:focus{
        outline:0px solid;
    }
  .el-col {
    border-radius: 4px;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
  .demo-drawer__footer{
    text-align:center;margin-top:50px;
  }
  .table_box_el_table{
        width: 100%;
        margin-top: 25px;
  }
    .el-table >>> thead tr th{
        background: #f1f1f1 !important;
        padding: 6px 0 !important;
        color: #777 !important;
    }
   /* /deep/ body {
    color:black;
  } */
  .el-tabs--card >>>.el-tabs__header .el-tabs__item.is-active {
    background-color: #fff;
    border-bottom-color: white;
    color: #337eff;
  }
  .el-tabs--card >>>.el-tabs__header .el-tabs__item {
    background-color: white;
    border: 1px solid #edeef0;
    color: black;
  }
  .el-drawer__wrapper >>> .el-drawer__header > span{
      font-size: 16px;
      border-left: #337eff solid 3px;
      line-height: 14px;
      padding-left: 10px;
  }
  .el-drawer__wrapper >>> .el-drawer__header{
      border-bottom: #e1e3e6 solid 1px;
      padding: 0px 0 10px 0;
      margin-bottom: 15px;
  }
  .el-drawer__wrapper >>> .el-drawer{
      padding: 20px;
  }
</style>
